import { Card, Divider, Flex, Grid, Paper, Stack, Text, Title } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import Button from '../../components/elements/Button';
import GridCell from '../../components/elements/GridCell';
import CardUnblock from './fragments/CardUnblock';
import CardBlock from './fragments/CardBlock';
import ModalProcessUnblockCustomer from '../../components/fragments/ModalProcessUnblockCustomer';
import HistoryBlock from '../../components/fragments/HistoryBlock';
import styles from './styles.scoped.css';
import IconCheck from '../../components/icons/IconCheck';
import IconClose from '../../components/icons/IconClose';
import { AppContext, ToastrContext } from '../../contexts';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllRedux, fetchDataCustomerUnblock, fetchHistoryBlock, fetchProcessUnblock, fetchProcessUnblockSubmission, fetchSummaryUnblockCustomer } from './actions';
import { useLocation, useNavigate } from 'react-router-dom';

const CustomerSubmissionUnblockDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  const nationalityId = location.pathname.split('/').pop();
  const { setToastr } = useContext(ToastrContext);
  const dispatch = useDispatch();
  const [modal, setModal] = useState({ opened: false, type: '' });
  const { setBreadcrumbs } = useContext(AppContext);

  const { dataDetailCustomerUnblock,
    dataHistoryBlock,
    isLoadingHistoryBlock,
    dataSummary,
    dataCustomerUnblock
  } =
  useSelector(({ customerSubmissionUnblock }) =>
    customerSubmissionUnblock);
  const dataDetail = type === 'search' ? dataCustomerUnblock : dataDetailCustomerUnblock;

  const submissionHandler = (response) => {
    setModal({
      type: modal.type,
      opened: false
    });
    if(response.success){
      if(dataSummary?.needVerification > 1 && type !== 'search'){
        const container = document.getElementById('children-container');
        dispatch(fetchProcessUnblock()).then((data) => {
          navigate(`/submission-unblock/detail/${data.nationalityId}`);
        }).catch(e => {
          setToastr({
            desc: e.message || 'Terjadi kesalahan pada sistem kami',
            type: 'danger',
            visible: true,
          });
        });
        dispatch(fetchSummaryUnblockCustomer());
        container.scroll({ top: 0, behavior: 'smooth' });
      }else{
        dispatch(clearAllRedux());
        navigate('/submission-unblock');
      }
      setToastr({
        visible: true,
        desc: `Berhasil ${modal.type === 'accept' ? 'menyetujui' : 'menolak'} pengajuan`,
        type: 'success'
      });
    }else{
      setToastr({
        visible: true,
        desc: response.message || `Terjadi kesalahan pada sistem kami`,
        type: 'danger'
      });
      dispatch(clearAllRedux());
      navigate('/submission-unblock');
    }
  };

  const handleSubmitProcess = (data) => {
    const bodyReq = {
      'reason': data.reason || '',
      'decision': modal.type === 'accept' ? 'APPROVED' : 'REJECTED',
      'documentSupportAdmin': data.file[0] || null,
      'acknowledged': data.agree
    };
    const formData = new FormData();
    Object.keys(bodyReq).forEach(key => {
      formData.append(key, bodyReq[key]);
    });
    dispatch(fetchProcessUnblockSubmission(dataDetail.requestId, formData,
      submissionHandler));
  };

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Pengajuan Buka Blokir', to: '/submission-unblock' },
      { name: 'Rincian Data Pelanggan' }]);
    dispatch(fetchSummaryUnblockCustomer());
    if(!dataDetailCustomerUnblock && type !== 'search'){
      dispatch(fetchProcessUnblock());
    }else if (type === 'search'){
      dispatch(fetchDataCustomerUnblock({
        nationalityId: nationalityId,
        status: 'PENDING'
      }));
    }
  }, []);
  return (
    <Stack>
      <Card withBorder>

        <Text c="#25282B" fw={500} fz={18}>{`${dataSummary?.accepted + dataSummary?.rejected} dari ${
          dataSummary?.total} data telah diverifikasi`}</Text>
      </Card>
      <Card withBorder>
        <Flex align="center" justify="space-between">
          <Title order={4}>Data Pelanggan</Title>
          <HistoryBlock historyBlock={dataHistoryBlock} isLoading={isLoadingHistoryBlock}
            onClick={() => dispatch(fetchHistoryBlock({
              nationalityId: dataDetail?.nationalityId,
              isMask: true
            }))}/>
        </Flex>
        <Divider my="md"/>
        <Paper>
          <GridCell data={dataDetail?.name} label="Nama" left={3} right={9}/>
          <GridCell data={dataDetail?.nationalityId} label="NIK KTP" left={3} right={9}/>
          <GridCell data={dataDetail?.customerTypes ? dataDetail?.customerTypes?.join(', ') : '-'} label="Jenis Pengguna" left={3} right={9}/>
        </Paper>
      </Card>
      <Card withBorder>
        <Title order={4}>Verifikasi Pengajuan Buka Blokir</Title>
        <Card.Section>
          <Divider my="md"/>
        </Card.Section>
        <Grid>
          <Grid.Col span={4}>
            <CardBlock data={dataDetail}/>
          </Grid.Col>
          <Grid.Col span={8}>
            <CardUnblock data={dataDetail}/>
          </Grid.Col>
        </Grid>
        <Card.Section>
          <Divider my="md" />
        </Card.Section>
        <Flex justify="space-between">
          <Button icon={<IconClose className={styles.iconClose} type="thin" />} onClick={() => setModal({
            type: 'reject',
            opened: true
          })} outlined style="danger">Tolak Pengajuan</Button>
          <Button color="green" icon={<IconCheck className={styles.iconCheck}/>} onClick={() => setModal({ type: 'accept', opened: true })}>Setujui Pengajuan</Button>
        </Flex>
      </Card>
      <ModalProcessUnblockCustomer handleSubmitProcess={handleSubmitProcess}
        modal={modal} setModal={setModal}/>
    </Stack>
  );
};

export default CustomerSubmissionUnblockDetail;
